/* ON: coletor do mapa de calor próprio do Painel ON.
   Junta, por tipo de página (home, coleção e PDP), até onde as pessoas rolam, o tempo ativo, onde ficam as partes da página
   e onde tocam (em células de 10% de cada parte). Manda um resumo por página vista, quando a pessoa sai da página.
   Sem cookie, sem identificar a pessoa e sem ler nada do que é digitado. Respeita a escolha de privacidade da Shopify. */
(function () {
  'use strict';
  try {
    var ENVIO = 'https://klseoibxewffzmrgdnaa.supabase.co/functions/v1/mapa-calor';
    var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page) || {};
    var pt = String(meta.pageType || ''), cam = location.pathname;
    var tipo = pt === 'home' || cam === '/' ? 'home' : pt === 'product' || /\/products\//.test(cam) ? 'pdp' : pt === 'collection' || /^\/collections\//.test(cam) ? 'colecao' : pt === 'searchresults' ? 'busca' : null;
    if (!tipo || !navigator.sendBeacon || !document.querySelector || !window.MutationObserver) return;
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === false) return;
    var disp = window.innerWidth < 768 ? 'm' : 'c';

    /* partes dentro da seção principal da PDP e da coleção (tema onmoveis); o resto são as seções da Shopify */
    var DENTRO = {
      pdp: [['galeria', '.gal'], ['nome', '.nomew'], ['comprar', '.prw, .opc--capa, .pick, .ctas'], ['prazo', '.ship'], ['tecnologia', '.fpe'], ['fabricacao', 'section.solta']],
      colecao: [['topo', '.cab--col'], ['cores', '.chips'], ['grade', '.grade'], ['ver_mais', '.colmais'], ['descricao', '.col-desc']]
    };
    function nomeSecao(el) {
      var id = (el.id || '').replace('shopify-section-', '');
      var nome = id.split('__').pop() || id;
      if (/header|cabecalho|anuncio|announcement/i.test(nome)) return 'header';
      if (/footer|rodape/i.test(nome)) return 'footer';
      return nome.replace(/[^a-z0-9_-]/gi, '').toLowerCase().slice(0, 40);
    }
    var partes = [];
    function caixa(els) {
      var t = Infinity, b = -Infinity, l = Infinity, r = -Infinity;
      els.forEach(function (el) { var x = el.getBoundingClientRect(); if (!x.height) return; t = Math.min(t, x.top + scrollY); b = Math.max(b, x.bottom + scrollY); l = Math.min(l, x.left + scrollX); r = Math.max(r, x.right + scrollX); });
      return isFinite(t) ? { t: t, b: b, l: l, r: r } : null;
    }
    function montar() {
      var lista = [];
      document.querySelectorAll('[id^="shopify-section-"]').forEach(function (sec) {
        var nome = nomeSecao(sec);
        var dentro = /main/.test(nome) ? DENTRO[tipo] : null;
        if (dentro) {
          dentro.forEach(function (d) { var els = [].slice.call(sec.querySelectorAll(d[1])); if (els.length) lista.push({ nome: d[0], els: els }); });
          [].slice.call(sec.querySelectorAll('section.acc')).forEach(function (acc, i, todos) {
            var tx = (acc.textContent || '').slice(0, 200).toLowerCase();
            lista.push({ nome: /avalia/.test(tx) || acc.id === 'avaliacoes' ? 'avaliacoes' : /custa/.test(tx) ? 'custo' : i === todos.length - 1 ? 'duvidas' : 'detalhes' + i, els: [acc] });
          });
        } else lista.push({ nome: nome, els: [sec] });
      });
      partes = lista.slice(0, 30);
    }
    var alt = function () { return Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0) || 1; };
    var fundo = innerHeight, ativo = 0, ultimo = Date.now(), cliques = [], enviado = false;
    function mexeu() { ultimo = Date.now(); }
    ['scroll', 'pointerdown', 'pointermove', 'keydown', 'touchstart'].forEach(function (ev) { addEventListener(ev, mexeu, { passive: true }); });
    addEventListener('scroll', function () { fundo = Math.max(fundo, scrollY + innerHeight); }, { passive: true });
    setInterval(function () { if (document.visibilityState === 'visible' && Date.now() - ultimo < 5000) ativo++; }, 1000);
    function interativo(el) { return el && el.closest ? el.closest('a, button, summary, label, select, [role="button"], input[type="submit"], input[type="button"], input[type="radio"], input[type="checkbox"]') : null; }
    function rotulo(el) {
      var i = interativo(el);
      if (i) { var tx = i.getAttribute('aria-label') || (i.tagName === 'INPUT' ? '' : i.textContent) || ''; return (i.tagName.toLowerCase() + ':' + tx.replace(/\s+/g, ' ').trim()).slice(0, 40); }
      if (el.closest && el.closest('img, picture, figure')) return 'img';
      return '';
    }
    document.addEventListener('click', function (e) {
      if (cliques.length >= 40 || !partes.length) return;
      var el = e.target, px = e.pageX, py = e.pageY, idx = -1, bx = null;
      for (var k = 0; k < partes.length; k++) {
        if (partes[k].els.some(function (x) { return x.contains(el); })) { idx = k; break; }
      }
      if (idx < 0) return;
      bx = caixa(partes[idx].els);
      if (!bx) return;
      var gx = Math.max(0, Math.min(9, Math.floor((px - bx.l) / Math.max(1, bx.r - bx.l) * 10)));
      var gy = Math.max(0, Math.min(9, Math.floor((py - bx.t) / Math.max(1, bx.b - bx.t) * 10)));
      var alvo = rotulo(el), morto = 0;
      if (interativo(el) || alvo === 'img') { cliques.push([idx, gx, gy, alvo, 0]); return; }
      /* toque em algo que não é botão nem link: morto se nada mudar na página em 0,7 s */
      var mudou = false, url = location.href;
      var ob = new MutationObserver(function () { mudou = true; });
      ob.observe(document.body, { childList: true, subtree: true, attributes: true });
      setTimeout(function () { ob.disconnect(); morto = mudou || location.href !== url ? 0 : 1; cliques.push([idx, gx, gy, alvo, morto]); }, 700);
    }, true);
    function enviar() {
      if (enviado) return;
      enviado = true;
      try {
        montar();
        var H = alt();
        var sec = partes.map(function (p) {
          var b = caixa(p.els);
          if (!b) return [p.nome, 0, 0, 0];
          var vis = Math.min(b.b - b.t, innerHeight) * 0.3;
          return [p.nome, Math.round(b.t / H * 1000) / 10, Math.round((b.b - b.t) / H * 1000) / 10, fundo >= b.t + vis ? 1 : 0];
        });
        var corpo = { v: 1, t: tipo, d: disp, h: Math.round(H / innerHeight * 10) / 10, s: Math.min(100, Math.round(fundo / H * 1000) / 10), a: ativo, sec: sec, c: cliques.slice(0, 40) };
        navigator.sendBeacon(ENVIO, new Blob([JSON.stringify(corpo)], { type: 'text/plain' }));
      } catch (e) { /* nunca atrapalha a loja */ }
    }
    setTimeout(montar, 2000);
    addEventListener('pagehide', enviar);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') enviar(); });
  } catch (e) { /* nunca atrapalha a loja */ }
})();
